import React, { createRef } from 'react';
import VideoPlaylistLabels from './properties/videoPlaylistLabels';

interface ToggleBtnProps {
  active: boolean;
  onToggle: () => void;
  labels: VideoPlaylistLabels;
}

const ToggleBtn = (props: ToggleBtnProps) => {
  const { active, onToggle, labels } = props;
  const checkboxRef = createRef<HTMLInputElement>();

  return (
    <div className="toggle-button-container">
      <h4 className="hl-4 toggle-button__headline">{labels.autoplayText.toUpperCase()}</h4>
      <a
        tabIndex={0}
        aria-label={labels.autoplayText}
        role="checkbox"
        aria-checked={active}
        className={`toggle-button  ${active ? 'active' : 'inactive'}`}
        onKeyDown={(event) => {
          const target = event.target as Element;

          if ([32, 13].includes(event.keyCode) && target.tagName !== 'INPUT') {
            event.preventDefault();
            const cref = checkboxRef.current;

            if (cref) {
              cref.toggleAttribute('checked');
              onToggle();
            }
          }
        }}
      >
        <input
          tabIndex={-1}
          ref={checkboxRef}
          type="checkbox"
          aria-hidden="true"
          className="toggle-button__checkbox"
          checked={active}
          onChange={() => onToggle()}
        />
        <div className="toggle-button__slider" aria-hidden="true">
          <span className="toggle-button__on">{labels.autoplayOn.toUpperCase()}</span>
          <span className="toggle-button__switch" />
          <span className="toggle-button__off">{labels.autoplayOff.toUpperCase()}</span>
        </div>
        <div className="toggle-button__layer" aria-hidden="true" />
      </a>
    </div>
  );
};

export default ToggleBtn;
